export const UPDATE_EMPLOYEE_FAILURE = 'UPDATE_EMPLOYEE_FAILURE';

export const updateEmployeeFailure = error => ({
    type: UPDATE_EMPLOYEE_FAILURE,
    payload: error,
    error: true,
});
